/**
 * Offline Indicator - Shows when the user loses internet connection
 */

import { WifiOff } from 'lucide-react';
import { useUIStore } from '@stores/ui.store';

export function OfflineIndicator(): JSX.Element | null {
  const isOnline = useUIStore((state) => state.isOnline);

  if (isOnline) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-ybh-error text-ybh-text-primary py-2 px-4 flex items-center justify-center gap-2 animate-slide-down">
      <WifiOff size={18} />
      <span className="text-sm font-medium">You're offline. Some features may not work.</span>
    </div>
  );
}
